"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "2.39.0", "build_date": "2022-07-06T12:25:51.148Z", "build_branch": "staging", "build_commit": "82368d4a69af726c03dec6719e92164ab15d6f08" };
